import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import './KOTComponent.css';

const KOTComponent = ({ order, outlet }) => {
  const kotRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => kotRef.current,
    documentTitle: `KOT-${order.kotNumber || order.orderNumber}`,
  });

  // Group items by category
  const groupedItems = (order.items || []).reduce((acc, item) => {
    const category = item.category || 'Other';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  return (
    <div className="kot-container">
      <button className="print-kot-btn" onClick={handlePrint}>
        🖨️ Print KOT
      </button>

      <div className="kot-preview" ref={kotRef}>
        <div className="kot-header">
          <div className="kot-logo">
            {outlet?.logo ? (
              <img src={outlet.logo} alt={outlet.name} />
            ) : (
              <div className="kot-logo-placeholder">🍽️</div>
            )}
          </div>
          <h2 className="kot-title">{outlet?.name || 'Restaurant'}</h2>
          <p className="kot-subtitle">KITCHEN ORDER TICKET</p>
        </div>

        <div className="kot-info">
          <div className="kot-info-row">
            <span className="kot-label">Table No:</span>
            <span className="kot-value table-highlight">AC {order.tableNumber}</span>
          </div>
          <div className="kot-info-row">
            <span className="kot-label">KOT No:</span>
            <span className="kot-value">{order.kotNumber || order.orderNumber}</span>
          </div>
          <div className="kot-info-row">
            <span className="kot-label">Date:</span>
            <span className="kot-value">
              {order.createdAt?.toDate
                ? new Date(order.createdAt.toDate()).toLocaleString()
                : new Date().toLocaleString()}
            </span>
          </div>
          <div className="kot-info-row">
            <span className="kot-label">Waiter:</span>
            <span className="kot-value">{order.waiterName || 'N/A'}</span>
          </div>
        </div>

        <div className="kot-items">
          {Object.entries(groupedItems).map(([category, items]) => (
            <div key={category} className="kot-category-section">
              <h3 className="kot-category-header">{category}</h3>
              {items.map((item, idx) => (
                <div key={idx} className="kot-item">
                  <div className="kot-item-image">
                    {item.image ? (
                      <img src={item.image} alt={item.name} />
                    ) : (
                      <div className="kot-item-placeholder">🍽️</div>
                    )}
                  </div>
                  <div className="kot-item-details">
                    <div className="kot-item-qty">{item.quantity}x</div>
                    <div className="kot-item-name">{item.name}</div>
                    {item.description && (
                      <div className="kot-item-desc">{item.description}</div>
                    )}
                    <div className="kot-item-order-id">
                      Order ID: {order.orderNumber}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className="kot-footer">
          <p className="kot-note">Please prepare the above items</p>
          <p className="kot-timestamp">
            Printed: {new Date().toLocaleTimeString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default KOTComponent;
